import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../state/state.types';

const mapState = ({ results }: StateType) => ({
  adviceAction: results.adviceAction,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
